// Ported from magicui.design/docs/shimmer-button — copy-paste component,
// owned code. Converted from TypeScript to JS. Two real adaptations beyond
// the TS strip:
//  1. Defaults changed to brand colors (rust bg, warm-white shimmer) instead
//     of the stock black/white.
//  2. `@container-[size]` + `h-[100cqh]` (container-query units) and
//     `inset-(--cut)` are Tailwind v4-only syntax — this project runs
//     Tailwind v3.4, which doesn't parse either, so the button would have
//     rendered with no spark at all. Swapped to plain v3-compatible
//     arbitrary-value syntax with the same visual result.
import React from "react";
import { cn } from "@/lib/utils";

export const ShimmerButton = React.forwardRef(
  (
    {
      shimmerColor = "#FBF6EE", // warm white, not cold white
      shimmerSize = "0.05em",
      shimmerDuration = "3s",
      borderRadius = "9999px",
      background = "#A13F2C", // brand rust red
      className,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        style={{
          "--spread": "90deg",
          "--shimmer-color": shimmerColor,
          "--radius": borderRadius,
          "--speed": shimmerDuration,
          "--cut": shimmerSize,
          "--bg": background,
        }}
        className={cn(
          "group relative z-0 flex cursor-pointer items-center justify-center overflow-hidden [border-radius:var(--radius)] border border-white/10 px-6 py-3 whitespace-nowrap text-paper [background:var(--bg)]",
          "transform-gpu transition-transform duration-300 ease-in-out active:translate-y-px",
          className,
        )}
        ref={ref}
        {...props}
      >
        {/* spark container */}
        <div className="absolute inset-0 -z-30 overflow-visible blur-[2px]">
          <div className="animate-shimmer-slide absolute inset-0 aspect-square h-full rounded-none">
            <div className="animate-spin-around absolute -inset-full w-auto rotate-0 [background:conic-gradient(from_calc(270deg-(var(--spread)*0.5)),transparent_0,var(--shimmer-color)_var(--spread),transparent_var(--spread))]" />
          </div>
        </div>

        {children}

        {/* highlight */}
        <div
          className={cn(
            "absolute inset-0 size-full",
            "rounded-2xl px-4 py-1.5 text-sm font-medium shadow-[inset_0_-8px_10px_rgba(255,255,255,0.12)]",
            "transform-gpu transition-all duration-300 ease-in-out",
            "group-hover:shadow-[inset_0_-6px_10px_rgba(255,255,255,0.25)]",
            "group-active:shadow-[inset_0_-10px_10px_rgba(255,255,255,0.25)]",
          )}
        />

        {/* backdrop */}
        <div className="absolute inset-[var(--cut)] -z-20 [border-radius:var(--radius)] [background:var(--bg)]" />
      </button>
    );
  },
);

ShimmerButton.displayName = "ShimmerButton";
